module.exports = __webpack_public_path__ + "static/img/8.d7fb70e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/13/sp/8.png
// module id = qzHn
// module chunks = 0